<!-- body wrapper  -->
<div class="body-wrapper" *ngIf="currentData">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content">
                    <h2 class="page-title">
                        Team Details
                    </h2>
                    <div class="page-url">
                        <a routerLink="/" class="old-page">Home </a> /
                        <p>Team details</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->
    <!-- ===========our team========= -->
    <section>
        <div class="team cpy-8">
            <div class="container">

                <div class="row">
                    <div class="col-md-4 mb-4">
                        <div class="team-card mts-5">
                            <img [src]="currentData?.image" alt="" class="team-img">
                            <div class="team-member-info">
                                <a>{{currentData?.name}}</a>
                                <p>{{currentData?.occupation}}</p>
                            </div>

                            <div class="user-social">
                                <ul class="user-social-ul">
                                    <li>
                                        <a [href]="currentData?.facebookLink" target="_blank" class="social-link"><i class="icofont-facebook"></i></a>
                                    </li>
                                    <li>
                                        <a [href]="currentData?.linkedinLink" target="_blank" class="social-link"><i class="icofont-linkedin"></i></a>
                                    </li>
                                    <li>
                                        <a [href]="currentData?.instaLink" target="_blank" class="social-link"><i class="icofont-instagram"></i></a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="team-about">
                            <div class="team-sec-title">
                                <h4 class="card-title">About Me</h4>
                            </div>
                            <p>
                                {{currentData?.details}}
                            </p>
                        </div>

                        <div class="team-about">
                            <div class="team-sec-title">
                                <h4 class="card-title">Personal Info</h4>
                            </div>
                            <div class="col-md-12">
                                <div class="team-info">
                                    <table class="table table-borderless team-info-table mb-0">
                                        <tr>
                                            <td class="ps-0 py-2">Educational Background:</td>
                                            <td class="fw-medium py-2">{{currentData?.educationalBg}}</td>
                                        </tr>
                                        <tr>
                                            <td class="ps-0 py-2">Phone:</td>
                                            <td class="fw-medium py-2">{{currentData?.phone}}</td>
                                        </tr>
                                        <tr>
                                            <td class="ps-0 py-2">Office:</td>
                                            <td class="fw-medium py-2">{{currentData?.office}}</td>
                                        </tr>

                                        <tr>
                                            <td class="ps-0 py-2">E-mail:</td>
                                            <td class="fw-medium py-2">{{currentData?.email}}</td>
                                        </tr>
                                        <tr>
                                            <td class="ps-0 py-2">Gender:</td>
                                            <td class="fw-medium py-2">{{currentData?.gender}}</td>
                                        </tr>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <!-- ===========our team end========= -->
</div>
<!-- body wrapper end -->